<template>
  <div class="dashboard-block">
    <h2>{{ $starLabel | sentenceCase }} Social Media Following</h2>

    <div class="row row-clear-xs-12">
      <div class="col-xs-12 col-md-6">
        <ladda-button
          class="btn btn-block btn-dark m-t-xs"
          :click="handleExportSocialMediaCsvCallback">
          Export Social Media CSV
        </ladda-button>
      </div>

      <div class="col-xs-12 col-md-6">
        <a data-toggle="modal" data-target="#modal-import-social-media-csv" class="btn btn-block btn-dark m-t-xs">
          Import Social Media CSV
        </a>
      </div>
    </div>

    <system-settings-social-media-modal/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SystemSettingsSocialMediaModal from './SystemSettingsSocialMediaModal'

export default {
  components: {
    SystemSettingsSocialMediaModal
  },

  methods: {
    ...mapActions('system', ['processTalentCsvExport']),

    handleExportSocialMediaCsvCallback () {
      return this.processTalentCsvExport()
        .then(({ data: { file_url: fileUrl, file, name } }) => {
          window.location.assign(fileUrl)
        })
    },

    handleImportSocialMediaCsvCallback () {

    }
  }
}
</script>
